module.exports = __webpack_public_path__ + "img/tablaMango.e807b5b6.jpg";